import React from 'react';
export default React.createContext({
  series: [],
  collections: [],
  domainsByItemId: {},
  subDomainsByItemId: {},
  updateDomains: function updateDomains() {
    return null;
  }
});